export default "assets/561eef512cf15e58500be078d5d6017b.png";